const elementClass = 'ripple';

export function fireRipple(event, ref) {
  if (ref && ref.current) {
    const node = ref.current;
    //set anim on ref element
    node.setAttribute('anim', 'ripple');
    node.classList.add('rippling');

    let rippleElement;
    // use ripple element if exists, otherwise create it
    if (!node.lastChild || node.lastChild.className !== elementClass) {
      rippleElement = document.createElement('span');
      rippleElement.className = elementClass;
      node.appendChild(rippleElement);
    } else {
      rippleElement = node.lastChild;
    }

    // set position for ripple animation using click location
    const x = event.pageX - node.offsetLeft;
    const y = event.pageY - node.offsetTop;
    rippleElement.setAttribute('style', `top:${y}px;left:${x}px;`);

    // after 400 ms remove the rippling class from the ref element
    setTimeout(() => {
      ref.current && ref.current.classList.remove('rippling');
    }, 400);
  }
}
